import colors from "./colors";

export const sortedSubjectsByCourse = {
  ACT: ["English", "Math", "Reading", "Science"],
  SAT: ["Reading", "Writing and Language", "Math"],
  dSAT: ["Reading & Writing", "Math"]
};

export const sortedSubjectsByCourseShort = {
  ACT: ["english", "math", "reading", "science"],
  SAT: ["reading", "writing", "math"],
  dSAT: ["reading & writing", "math", "math"]
};

export const colorBarBySubject = {
  "Writing and Language": colors.instructorGreen,
  "Reading & Writing": colors.orange,
  English: colors.instructorGreen,
  Math: colors.blue,
  Reading: colors.orange,
  Science: colors.yellow
};

export const subjectsId = {
  student_test_scores_sat_math: "a6141126-e7b2-40f7-8f9d-564013f7e94c",
  student_test_scores_sat_reading: "0cb219c2-881a-4326-847e-1ab79441679e",
  student_test_scores_sat_writing: "5e2f3400-c363-4fdd-8ea1-bc2de9643321",
  student_test_scores_act_math: "a118199d-e8df-41c5-a2ea-980795f7b97d",
  student_test_scores_act_reading: "cf28a1ea-ed58-4e07-81a7-13d760fd9dbc",
  student_test_scores_act_english: "71b7ddc8-5092-409d-9474-c0605880d416",
  student_test_scores_act_science: "1cf3595a-d3c3-420d-b9d7-28da3d35d92d"
};

export const courseId = {
  SAT: "424f19e3-97ff-41e4-824b-ac89719f6906",
  ACT: "6293e6ab-b103-4e3d-a246-5d37d3457e93"
};

export const BUBBLE_SCHEME: IProblemBubbles[] = [
  {
    id: 0,
    label: "A",
    altLabel: "F",
    value: "A"
  },
  {
    id: 1,
    label: "B",
    altLabel: "G",
    value: "B"
  },
  {
    id: 2,
    label: "C",
    altLabel: "H",
    value: "C"
  },
  {
    id: 3,
    label: "D",
    altLabel: "J",
    value: "D"
  },
  {
    id: 4,
    label: "E",
    altLabel: "K",
    value: "E"
  }
];
